/* Le bandeau video du haut de l accueil n existe QUE sur bureau : sous 750 px
   Horizon le met en `display: none` et affiche l image mobile a la place.
   Mais le meme HTML part vers les deux, et un `<video autoplay muted>` masque
   en CSS lance quand meme son chargement — mesure du 18/09 sur Lighthouse
   mobile : 13,7 Mo tires pour la piste `HD-1080p-7.2M` d un element jamais
   visible. `hero.liquid` retire donc `autoplay` et passe `preload` a `none` ;
   c est ici qu on rend la lecture, et seulement quand la requete media bureau
   est vraie.

   2e mesure, le 18/09 aussi : l accueil porte DEUX bandeaux video de 27 Mo
   chacun. Les demarrer tous les deux au chargement faisait 54,6 Mo sur BUREAU,
   alors que le second est sous la ligne de flottaison et que la plupart des
   visiteurs ne le voient jamais. Chaque video n est donc armee qu a son entree
   dans l ecran. Le premier bandeau est visible d emblee : son observateur se
   declenche immediatement, sans delai perceptible. */
(function () {
  var mq = window.matchMedia('(min-width: 750px)');
  var enAttente = [];

  function lancer(v) {
    if (v.dataset.lvVideoBureau === 'ok') return;
    v.dataset.lvVideoBureau = 'ok';
    v.preload = 'auto';
    v.muted = true;
    v.setAttribute('autoplay', '');
    var p = v.play();
    /* un refus de lecture automatique laisse le poster : pas d erreur console */
    if (p && p.catch) p.catch(function () {});
  }

  function armer() {
    if (!mq.matches) return;
    document.querySelectorAll('video[data-lv-video-bureau]').forEach(function (v) {
      if (v.dataset.lvArme === '1') return;
      v.dataset.lvArme = '1';
      if (!window.IntersectionObserver) { lancer(v); return; }
      /* `rootMargin` genereux : la video est prete quand le bandeau arrive,
         pas au moment ou il est deja a l ecran. */
      var io = new IntersectionObserver(function (e, obs) {
        if (!e[0].isIntersecting) return;
        obs.disconnect();
        lancer(v);
      }, { rootMargin: '200px 0px' });
      io.observe(v);
      enAttente.push(v);
    });
  }

  if (mq.addEventListener) mq.addEventListener('change', armer);
  else if (mq.addListener) mq.addListener(armer);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', armer);
  else armer();
})();
